import styled from '@emotion/styled';
import {Markdown} from '@travel-frontend/ui-components';

import {Container} from '@/modules/hotels/components/SeaSpotlight/components/Badge/components/Content/components/Container';

type Props = {
  content: string;
};
export const Content: React.FunctionComponent<Props> = styled(
  ({content}: Props) => (
    <Container>
      <Markdown value={content} />
    </Container>
  )
)``;
